// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/token.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message omnios.v1.ApiToken
 */
export const ApiToken = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApiToken",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "service_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "token_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "scopes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "expires_at", kind: "message", T: Timestamp },
    { no: 9, name: "last_used_at", kind: "message", T: Timestamp },
    { no: 10, name: "revoked_at", kind: "message", T: Timestamp },
    { no: 11, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ServiceAccount
 */
export const ServiceAccount = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ServiceAccount",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_at", kind: "message", T: Timestamp },
    { no: 8, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.DeviceAuthorization
 */
export const DeviceAuthorization = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeviceAuthorization",
  () => [
    { no: 1, name: "device_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "verification_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "expires_in", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "interval", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CreatePersonalTokenRequest
 */
export const CreatePersonalTokenRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePersonalTokenRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "scopes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "expires_in_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CreatePersonalTokenResponse
 */
export const CreatePersonalTokenResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePersonalTokenResponse",
  () => [
    { no: 1, name: "token", kind: "message", T: ApiToken },
    { no: 2, name: "plaintext", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPersonalTokensRequest
 */
export const ListPersonalTokensRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPersonalTokensRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListPersonalTokensResponse
 */
export const ListPersonalTokensResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPersonalTokensResponse",
  () => [
    { no: 1, name: "tokens", kind: "message", T: ApiToken, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.RevokeTokenRequest
 */
export const RevokeTokenRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RevokeTokenRequest",
  () => [
    { no: 1, name: "token_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RevokeTokenResponse
 */
export const RevokeTokenResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RevokeTokenResponse",
  [],
);

/**
 * @generated from message omnios.v1.CreateServiceAccountRequest
 */
export const CreateServiceAccountRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateServiceAccountRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateServiceAccountResponse
 */
export const CreateServiceAccountResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateServiceAccountResponse",
  () => [
    { no: 1, name: "service_account", kind: "message", T: ServiceAccount },
  ],
);

/**
 * @generated from message omnios.v1.ListServiceAccountsRequest
 */
export const ListServiceAccountsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListServiceAccountsRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListServiceAccountsResponse
 */
export const ListServiceAccountsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListServiceAccountsResponse",
  () => [
    { no: 1, name: "service_accounts", kind: "message", T: ServiceAccount, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetServiceAccountRequest
 */
export const GetServiceAccountRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetServiceAccountRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetServiceAccountResponse
 */
export const GetServiceAccountResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetServiceAccountResponse",
  () => [
    { no: 1, name: "service_account", kind: "message", T: ServiceAccount },
  ],
);

/**
 * @generated from message omnios.v1.DeleteServiceAccountRequest
 */
export const DeleteServiceAccountRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteServiceAccountRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteServiceAccountResponse
 */
export const DeleteServiceAccountResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteServiceAccountResponse",
  [],
);

/**
 * @generated from message omnios.v1.CreateServiceAccountTokenRequest
 */
export const CreateServiceAccountTokenRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateServiceAccountTokenRequest",
  () => [
    { no: 1, name: "service_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "scopes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "expires_in_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateServiceAccountTokenResponse
 */
export const CreateServiceAccountTokenResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateServiceAccountTokenResponse",
  () => [
    { no: 1, name: "token", kind: "message", T: ApiToken },
    { no: 2, name: "plaintext", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListServiceAccountTokensRequest
 */
export const ListServiceAccountTokensRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListServiceAccountTokensRequest",
  () => [
    { no: 1, name: "service_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListServiceAccountTokensResponse
 */
export const ListServiceAccountTokensResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListServiceAccountTokensResponse",
  () => [
    { no: 1, name: "tokens", kind: "message", T: ApiToken, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.StartDeviceAuthorizationRequest
 */
export const StartDeviceAuthorizationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StartDeviceAuthorizationRequest",
  () => [
    { no: 1, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "scopes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.StartDeviceAuthorizationResponse
 */
export const StartDeviceAuthorizationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StartDeviceAuthorizationResponse",
  () => [
    { no: 1, name: "authorization", kind: "message", T: DeviceAuthorization },
  ],
);

/**
 * @generated from message omnios.v1.ApproveDeviceAuthorizationRequest
 */
export const ApproveDeviceAuthorizationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApproveDeviceAuthorizationRequest",
  () => [
    { no: 1, name: "user_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ApproveDeviceAuthorizationResponse
 */
export const ApproveDeviceAuthorizationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApproveDeviceAuthorizationResponse",
  [],
);

/**
 * @generated from message omnios.v1.DenyDeviceAuthorizationRequest
 */
export const DenyDeviceAuthorizationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DenyDeviceAuthorizationRequest",
  () => [
    { no: 1, name: "user_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DenyDeviceAuthorizationResponse
 */
export const DenyDeviceAuthorizationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DenyDeviceAuthorizationResponse",
  [],
);

/**
 * @generated from message omnios.v1.PollDeviceAuthorizationRequest
 */
export const PollDeviceAuthorizationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PollDeviceAuthorizationRequest",
  () => [
    { no: 1, name: "device_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PollDeviceAuthorizationResponse
 */
export const PollDeviceAuthorizationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PollDeviceAuthorizationResponse",
  () => [
    { no: 1, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plaintext_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SearchKey
 */
export const SearchKey = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchKey",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "token_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "allowed_origins", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "rate_limit_rpm", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "expires_at", kind: "message", T: Timestamp },
    { no: 8, name: "last_used_at", kind: "message", T: Timestamp },
    { no: 9, name: "revoked_at", kind: "message", T: Timestamp },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "scopes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateSearchKeyRequest
 */
export const CreateSearchKeyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateSearchKeyRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "allowed_origins", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "rate_limit_rpm", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "expires_in_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "scopes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateSearchKeyResponse
 */
export const CreateSearchKeyResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateSearchKeyResponse",
  () => [
    { no: 1, name: "key", kind: "message", T: SearchKey },
    { no: 2, name: "plaintext", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListSearchKeysRequest
 */
export const ListSearchKeysRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListSearchKeysRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListSearchKeysResponse
 */
export const ListSearchKeysResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListSearchKeysResponse",
  () => [
    { no: 1, name: "keys", kind: "message", T: SearchKey, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.RevokeSearchKeyRequest
 */
export const RevokeSearchKeyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RevokeSearchKeyRequest",
  () => [
    { no: 1, name: "key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RevokeSearchKeyResponse
 */
export const RevokeSearchKeyResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RevokeSearchKeyResponse",
  [],
);

/**
 * @generated from message omnios.v1.GetSearchKeyUsageRequest
 */
export const GetSearchKeyUsageRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetSearchKeyUsageRequest",
  () => [
    { no: 1, name: "key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetSearchKeyUsageResponse
 */
export const GetSearchKeyUsageResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetSearchKeyUsageResponse",
  () => [
    { no: 1, name: "current_month_queries", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "included_queries", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "plan_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.IntrospectTokenRequest
 */
export const IntrospectTokenRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.IntrospectTokenRequest",
  [],
);

/**
 * @generated from message omnios.v1.IntrospectTokenResponse
 */
export const IntrospectTokenResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.IntrospectTokenResponse",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "scopes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_service_account", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_agent", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "expires_at", kind: "message", T: Timestamp },
  ],
);

